module.exports = __webpack_public_path__ + "img/15_65.095d3089.png";